import { render, staticRenderFns } from "./SupplierForm.vue?vue&type=template&id=6cb9693e&scoped=true"
import script from "./SupplierForm.vue?vue&type=script&lang=js"
export * from "./SupplierForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb9693e",
  null
  
)

export default component.exports